<template>
	<div>
		<div class="margin-top5 padding-bottom15 line-height20 flex-start" v-for="(news,newsindex) in list" :key="newsindex"
			@click="$toPage('news/'+news.id)">
			<img v-if="news.images_url" class="margin-right10 bg-grey" :class="imgClass" :src="news.images_url" alt="" />
			<div class="width75p">
				<div class="font20 margin-bottom5 line-1 card-title margin-top10" v-html="highlightText(news.title)"></div>
				<div class="margin-bottom10 news-content margin-top10" :class="imgClass=='news-img'?'line-1 ':'line-2'"
					v-html="news.content">
				</div>
				<div class="flex-startCenter font14 color-grey9 " :class="imgClass=='news-img'?'margin-top20':'margin-top10'">
					<img v-if="news.source" src="@/assets/images/icon-book.png" class="width16 height16" alt="" />
					<div v-if="news.source" class="padding-right26 margin-left3">{{news.source}}</div>
					<img src="@/assets/images/icon-time.png" class="width16 height16" alt="" />
					<div class="">{{news.created_at}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		favorite
	} from '@/api/user'
	import {
		compare
	} from '@/api/school'

	export default {
		name: 'ItemNews',
		props: {
			list: {
				type: Array,
				default () {
					return []
				}
			},
			keyword: {
				type: String,
				default: ''
			},
			imgClass: {
				type: String,
				default: 'news-img'
			}
		},
		data() {
			return {

			}
		},
		methods: {
			highlightText(text) {
				if (!this.keyword || !text) return text;

				// 按空格分割关键词
				const keywords = this.keyword.trim().split(/\s+/).filter(k => k.length > 0);

				if (keywords.length === 0) return text;

				// 转义并组合正则表达式
				const escapedKeywords = keywords.map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
				const regex = new RegExp(`(${escapedKeywords.join('|')})`, 'gi');

				// 替换匹配的文本
				return text.replace(regex, '<span class="highlight-text">$1</span>');
			},
			toDetail(type, id) {
				if (!this.detail) {
					this.$router.push(`/${type}/${id}`)
				}
			}
		},
	}
</script>

<style lang="scss" scoped>
	.card-title {
		font-weight: normal;
		line-height: 28px;
	}

	.news-img {
		width: 175px;
		height: 114px;
		border-radius: 6px
	}

	.news-img1 {
		width: 210px;
		height: 136px;
		border-radius: 6px
	}

	.news-content {


		:deep(p) {
			font-size: 14px !important;
			color: #606266 !important;
			margin: 0 !important;
			padding: 0 !important;
			line-height: 24px;
		}
	}
</style>